module.exports = __webpack_public_path__ + "img/placeholder-company.a0098f7b.svg";